import {
  DEFAULT_JURISDICTION_ID,
  JURISDICTIONS,
  JurisdictionId,
} from '../../types/jurisdiction';
import {
  IJurisdictionState,
  JurisdictionActionTypes,
  SET_ALLOWED_JURISDICTIONS,
  SET_JURISDICTION,
} from './types';

const STORAGE_KEY = 'jurisdiction';

function readPersistedId(): JurisdictionId {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_JURISDICTION_ID;
    const match = JURISDICTIONS.find((j) => j.id === raw && !j.disabled);
    return match ? match.id : DEFAULT_JURISDICTION_ID;
  } catch {
    return DEFAULT_JURISDICTION_ID;
  }
}

function persistId(id: JurisdictionId) {
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch {
    // ignore storage errors (private mode, quota)
  }
}

const initialState: IJurisdictionState = {
  activeId: readPersistedId(),
  // Most restrictive default until the backend tells us what this user may access.
  allowedIds: [DEFAULT_JURISDICTION_ID],
};

export function jurisdictionReducer(
  state: IJurisdictionState = initialState,
  action: JurisdictionActionTypes | any
): IJurisdictionState {
  switch (action.type) {
    case SET_JURISDICTION: {
      persistId(action.payload);
      return { ...state, activeId: action.payload };
    }
    case SET_ALLOWED_JURISDICTIONS: {
      const allowedIds: JurisdictionId[] = action.payload;
      // If the currently active jurisdiction isn't allowed anymore, fall back to
      // the US default so the user is never left on a disabled jurisdiction.
      const activeId = allowedIds.includes(state.activeId)
        ? state.activeId
        : DEFAULT_JURISDICTION_ID;
      if (activeId !== state.activeId) {
        persistId(activeId);
      }
      return { ...state, allowedIds, activeId };
    }
    default:
      return state;
  }
}
